export default function ({ route, from, app, redirect, $auth, $helpers }) {
    if ($auth.loggedIn && route.path.includes('/en/') && !route.path.includes('/Login')) {
        const locale = $helpers.getLocale()
        if (locale !== 'ar' && !$auth.user.features.viewTranslations) {
            redirect(app.localePath(route.path, 'ar'))
        }
    }
}
